<div class="back-to-list">
  <div class="navigation-left">
    <a class="arrow arrow-left" (click)="goBack()">{{ backToLabel }}</a>
  </div>
</div>

<mat-card>
  <mat-card-title>{{ 'mass-messaging-details/title' | translate }}</mat-card-title>
  <mat-card-content>
    <div class="grid-container">
      <div>
        <label translate="mass-messaging-details/id"></label>
        <span class="value">{{ campaign.id }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/name"></label>
        <span>
          <ng-container *ngIf="campaign.is_test">
            <span class="testing-badge">
              {{ 'mass_messaging/testing-flag' | translate }}
            </span>
            &nbsp;
          </ng-container>
          {{ campaign.name }}
        </span>
      </div>

      <div>
        <label translate="mass-messaging-details/account"></label>
        <app-site-icon-and-name [item]="campaign.tmpFields?.account">{{
          campaign.tmpFields?.account?.siteName
        }}</app-site-icon-and-name>
      </div>

      <div>
        <label translate="mass-messaging-details/status"></label>
        <ng-container *ngIf="massMessagingService.getStatusLabel(campaign) as label">
          <mat-chip-list>
            <mat-chip
              [ngClass]="MassMessagingStatusEnum[campaign.status]"
              [selected]="campaign.status !== MassMessagingStatusEnum.COMPLETED_STATUS">
              {{ label }}</mat-chip
            >
          </mat-chip-list>
        </ng-container>
      </div>

      <div>
        <label translate="mass-messaging-details/scenario"></label>
        <a *ngIf="campaign.scenario?.link; else scenarioWithoutLink" [href]="campaign.scenario.link" target="_blank">{{
          campaign.scenario.name
        }}</a>
        <ng-template #scenarioWithoutLink>
          <span>{{ campaign.scenario?.name || ('mass_messaging/scenario/not_found' | translate) }}</span>
        </ng-template>
      </div>

      <div>
        <label translate="mass-messaging-details/segment"></label>
        <span>{{ campaign.audience_filters?.segmentName || ('mass_messaging/segment/not_found' | translate) }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/scheduled"></label>
        <span class="value">{{ campaign.scheduledLabel }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/starter-admin-user-id"></label>
        <span class="value">{{ campaign.sentByLabel }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/start-time"></label>
        <span class="value">{{ campaign.startTime | dateTimezone: 'short' }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/end-time"></label>
        <span class="value">{{ campaign.endTime | dateTimezone: 'short' }}</span>
      </div>

      <div *ngIf="campaign.isScheduled">
        <label translate="mass-messaging-details/scheduled-time"></label>
        <span class="value">{{ campaign.scheduledTime }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/sent"></label>
        <span class="value">{{ campaign.numberOfMessagesSuccessfullySent }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/remains"></label>
        <span class="value">{{ campaign.remainingNumberOfMessagesToSend }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/errors"></label>
        <span class="value">{{ campaign.numberOfErrors }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/read"></label>
        <span class="value">{{ campaign.read }}</span>
      </div>

      <div>
        <label translate="mass-messaging-details/not-sent"></label>
        <span class="value">{{ campaign.numberOfMessagesNotSent }}</span>
      </div>
    </div>
  </mat-card-content>

  <app-card-footer [data]="footerContent"></app-card-footer>
</mat-card>
